export const CHAIN_IDS = {
    MAINNET: '1',
    SEPOLIA: '11155111',
    GOERLI: '5',
};
